import React, { useState } from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import PersonOutlineRoundedIcon from "@mui/icons-material/PersonOutlineRounded";
import GroupsOutlinedIcon from "@mui/icons-material/GroupsOutlined";
import { useSelector } from "react-redux";
import MyAttendance from "./MyAttendance";
import TeamAttendance from "./TeamAttendance";
import "../../assets/scss/tables.scss";
import "./Attendance.scss";

const Panel = ({ children, value, index }) => (
    <div role="tabpanel" hidden={value !== index}
        id={`attendance-panel-${index}`}
        aria-labelledby={`attendance-tab-${index}`}>
        {value === index && <Box sx={{ pt: 2 }}>{children}</Box>}
    </div>
);

const Attendance = () => {

    const [value, setValue] = useState(0);

    const { user } = useSelector((state) => state.WorkHubAppSlice);
    const canSeeTeam = Boolean(user?.roles?.isTeam);

    return (
        <div className="wh-table attendance-page">
            <Tabs value={value} onChange={(e, v) => setValue(v)}
                aria-label="attendance" className="wh-tabs">
                <Tab label="My Attendance" disableRipple
                    icon={<PersonOutlineRoundedIcon />} iconPosition="start"
                    id="attendance-tab-0" aria-controls="attendance-panel-0" />
                {canSeeTeam && <Tab label="Team Attendance" disableRipple
                    icon={<GroupsOutlinedIcon />} iconPosition="start"
                    id="attendance-tab-1" aria-controls="attendance-panel-1" />}
            </Tabs>

            <Panel value={value} index={0}><MyAttendance /></Panel>
            {canSeeTeam && <Panel value={value} index={1}><TeamAttendance /></Panel>}
        </div>
    );
};

export default Attendance;
